/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs'

const $nsid = 'app.bsky.unspecced.getAtmosphereApps'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  category: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxLength: 100 }),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  apps: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<AppCard>((() => appCard) as any),
    { maxLength: 100 },
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get curated Atmosphere apps. Authentication is optional; authenticated requests include viewer-specific profile state and known followers. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type AppCard = {
  $type?: 'app.bsky.unspecced.getAtmosphereApps#appCard'
  id?: string
  title?: string
  description?: string

  /**
   * The app's logo, using its account avatar when available.
   */
  logo?: l.UriString

  /**
   * The app's banner, using its account banner when available.
   */
  banner?: l.UriString
  url?: l.UriString
  category?: string

  /**
   * The app's account profile, when available.
   */
  profile?: ActorDefs.ProfileViewDetailed
}

export type { AppCard }

const appCard = /*#__PURE__*/ l.typedObject<AppCard>(
  $nsid,
  'appCard',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 4096 })),
    title: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
    logo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri', maxLength: 4096 }),
    ),
    banner: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri', maxLength: 4096 }),
    ),
    url: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri', maxLength: 4096 }),
    ),
    category: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 100 }),
    ),
    profile: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewDetailed>(
        (() => ActorDefs.profileViewDetailed) as any,
      ),
    ),
  }),
)

export { appCard }
